import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdClose,
  MdCloud,
  MdImage,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Edit.css";
import Spinner from "../components/Spinner";
import { useNavigate, useParams } from "react-router";
import { isEmpty } from "../functions/isEmpty";

export default function Edit({ isMobile, user, setUser }) {
  const [isLoading, setIsLoading] = useState(false);
  const [changesMade, setChangesMade] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [imageUploads, setImageUploads] = useState([]);

  const { id } = useParams();
  let navigate = useNavigate();

  const insertLocalImage = () => {
    return;
  };

  return (
    <div className="edit">
      <div className="edit_topnav">
        <div className="edit_topnav_back" onClick={() => navigate(-1)}>
          <ArrowBack /> Edit Profile
        </div>
      </div>
      <div className="edit_body">
        <div className="edit_body_display">
          <div className="edit_body_display_headline">Bild und Name</div>
          <div className="edit_body_display_inputbox">
            <input
              className="d-none"
              id="imgInp"
              type="file"
              accept="image/*"
              onChange={(e) => insertLocalImage(e)}
            />
            {isEmpty(imageUploads) ? (
              <label
                htmlFor={"imgInp"}
                className="edit_body_display_inputbox_imginput">
                <ImgIcon />
              </label>
            ) : (
              <>
                {isLoading ? (
                  <Spinner type="small" />
                ) : (
                  <>
                    <div
                      className="edit_body_display_inputbox_closebtn"
                      onClick={() => setImageUploads([])}>
                      <CloseIcon />
                    </div>
                    <img
                      src={imageUploads[0].localURL}
                      className="edit_body_display_inputbox_img"
                    />
                  </>
                )}
              </>
            )}
            <input
              type="text"
              className="edit_body_display_inputbox_nameinput"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Name eingeben"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const ImgIcon = styled(MdImage)`
  font-size: 25px;
  color: #474747;
`;

const CloudIcon = styled(MdCloud)`
  font-size: 18px;
  color: #474747;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 18px;
  color: #474747;
  margin-bottom: -3px;
`;

const CloseIcon = styled(MdClose)`
  font-size: 18px;
  color: rgb(111, 111, 111);
`;
